module.exports = [
	{id: 1, valor: "Pobreza Extrema"},
	{id: 31, valor: "Pobreza"},
	{id: 11, valor: "Media"},
	{id: 21, valor: " Alta"}
]


// WEBPACK FOOTER //
// ./src/components/Catalogs/SocioeconomicRanges/index.js